/* PV-1269 gallery fix — staged 2026-08-10 (drb.dig)
   Bug: theme.js onVariantChange_fn only moves the gallery when the newly
   selected variant HAS a featured_media. A variant with no bound image keeps
   the previous variant's chart on screen, so customers buy the wrong chart
   (422 SKUs affected; proven on revised-series-sloan-letter-etdrs).
   Fix: when the new variant has no featured_media and the previous one did,
   reset the gallery to its first visible media so nothing stale stays on screen.
   The theme dispatches variant:change on the product form with bubbles:true,
   so this document-level listener runs safely after the theme's own handler.
   Remove this file once the else-branch lands in theme.js itself. */
(function () {
  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant || variant.featured_media) return; /* theme already handles this case */
    if (!detail.previousVariant || !detail.previousVariant.featured_media) return; /* nothing stale on screen */
    var formId = detail.formId || (event.target && event.target.id);
    if (!formId) return;
    document.querySelectorAll('product-gallery[form="' + formId + '"]').forEach(function (gallery) {
      var carousel = gallery.querySelector('.product-gallery__carousel');
      if (!carousel) return;
      try {
        if (carousel.isScrollable && typeof carousel.select === 'function') {
          carousel.select(0, { instant: true });
        } else {
          var firstCell = carousel.querySelector('[data-media-id]');
          if (firstCell) firstCell.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      } catch (e) { /* never break the product page over a gallery reset */ }
    });
  });
})();
